import { removeMakerPageClass } from '../mp_maker.js';
import { onbeforeunload_event_off } from '../util.js';
import { disposeVideo } from '../CvBpcfVideo/fs.js';

export async function unsetMakerPage() {
  $.off(window, 'resize.maker');
  removeMakerPageClass();
  onbeforeunload_event_off();
  disposeVideo();
}
